module.exports = __webpack_public_path__ + "static/img/file-folder.ead54544.svg";